import { useState, useEffect, useContext } from 'react'
import { OrderEngineContext } from '../contexts/OrderEngineContext'

export default function useClient() {
  const { iExist: hasContext, client, catalogLoading, languageCode,
    app, brandID, brandName, token, apiUrl, setActiveBasketUUID, activeBasketUUID, setSelectedLocationUUID,
    setLanguageCode,
    socketAuthenticated, socketConnected,
    locations,
    languages,
    currencies, defaultLanguageCode,
    ordersInited, deviceLocationUUID, selectedLocationUUID, tokenData, catalogUpdated, 
    setCatalogUpdated, appParams, deviceParams, previewMode, sandboxMode, setSandboxMode,
    demoMode, entityState, entities, deviceStates, deviceSandbox, setToken, refreshUsers
  } = useContext(OrderEngineContext) || {}
  const [error, setError] = useState(null)

  useEffect(() => {
    if (error != null) {
      console.log(error)
    }
  }, [error])

  useEffect(() => {
    if (!hasContext) {
      setError('Component not wrapped in OrderEngineContext provider')
      return
    } else {
      setError(null)
    }
  }, [hasContext])

  const setActiveBasket = (uuid) => {
    setActiveBasketUUID(uuid)
  }

  const setSelectedLocation = (uuid) => {
    //console.log('setSelectedLocation - ZZZ111', uuid)
    if (deviceLocationUUID == null) {
      if (uuid != null) setSelectedLocationUUID(uuid)
    }
  }

  const setLanguage = (code) => {
    setLanguageCode(code)
  }

  const getName = (name, defTransKey) => {
    if (name == null && defTransKey == null) return ''
    let nameStr = (name?.[languageCode]?.length > 0
      ? name?.[languageCode]
      : name?.[defaultLanguageCode])
    let nameDefStr = (defTransKey?.[languageCode]?.length > 0
      ? defTransKey?.[languageCode]
      : defTransKey?.[defaultLanguageCode])
    return nameStr || nameDefStr || ''
  }

  const refreshCatalog = () => {
    client?.refreshCatalog()
    setCatalogUpdated(false)
  }

  return {
    socketConnected,
    socketAuthenticated,
    catalogLoading,
    locations,
    languages,
    currencies,
    client,
    hasContext,
    error,
    brandID,
    brandName,
    ordersInited,
    setActiveBasket,
    activeBasketUUID,
    languageCode,
    defaultLanguageCode,
    apiUrl,
    app,
    setSelectedLocation,
    selectedLocationUUID,
    deviceLocationUUID,
    setLanguage,
    tokenData,
    token,
    getName,
    catalogUpdated,
    refreshCatalog,
    appParams,
    deviceParams,
    sandboxMode,
    previewMode,
    setSandboxMode,
    demoMode,
    entityState, 
    entities,
    deviceStates,
    deviceSandbox,
    setToken,
    refreshUsers
  }
}
